export const quoteBlock = `
_type == 'quoteBlock' => {
  "quote": quote[_key == $lang][0].value,
  "caption": caption[_key == $lang][0].value,
}
`
